module.exports = __webpack_public_path__ + "static/11-6b492661d21c96f8a73c435e8220519b.jpeg";